<template>
    <div class="card">
        <h4 class="card-header d-flex align-items-center" style="height: 48px;">
            <span class="text-truncate mr-auto">
                {{ label }}
            </span>

            <ToggleInput
                v-if="canToggleAll"
                :value="allOptionsSelected"
                :disabled="disabled"
                @input="(value) => toggleAll(value)" />
        </h4>

        <slot />

        <div v-if="isEmpty" class="card-body">
            {{ emptyItemsLabel }}
        </div>

        <ul v-else class="list-group list-group-flush">
            <li
                v-for="option in options"
                :key="option.id"
                class="list-group-item d-flex align-items-center">
                <label class="m-0">
                    <ToggleInput
                        :value="optionIsSelected(option)"
                        :disabled="disabled"
                        @input="(value) => toggleOption(option, value)" />

                    <span class="ml-2">
                        {{ option.name }}
                    </span>
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import ToggleInput from '@/js/components/common/inputs/ToggleInput';

export default {
    name: 'ToggleListInput',

    components: {ToggleInput},

    model: {prop: 'values'},

    props: {
        label: {type: String, required: true},
        values: {type: Array, required: true},
        options: {type: Array, required: true},
        canToggleAll: {type: Boolean},
        emptyLabel: {type: String, default: null},
        disabled: {type: Boolean},
    },

    computed: {
        isEmpty() {
            return this.options.length === 0;
        },

        allOptionsSelected() {
            if (this.values.length === 0) {
                return false;
            }

            const allSelected = this.options
                .every((option) => this.values.some((value) => option.id === value));

            return allSelected === true ? true : null;
        },

        emptyItemsLabel() {
            return this.emptyLabel || this.$t('common.empty');
        },
    },

    methods: {
        optionIsSelected(option) {
            return this.values.some((value) => option.id === value);
        },

        toggleOption(option, value) {
            const values = this.values.filter((value) => value !== option.id);

            if (value === true) {
                this.$emit('input', [...values, option.id]);
            } else {
                this.$emit('input', values);
            }
        },

        toggleAll(value) {
            if (value === true) {
                this.$emit('input', this.options.map((option) => option.id));
            } else {
                this.$emit('input', []);
            }
        },
    },
};
</script>
